import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AUTH_MFA_ROUTE } from '../shared/constants/routes';
import { AuthMfaComponent } from './auth-mfa/auth-mfa.component';
import { PendingCognitoGuard } from '../guards/pending-cognito.guard';

const routes: Routes = [
  {
    path: AUTH_MFA_ROUTE,
    component: AuthMfaComponent,
    canActivate: [PendingCognitoGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthMfaRoutingModule {}
